<template>
  <div :class="['layout', isAndroid, isIOS, isChrome, isSafari, isMobileSafari, props.className]" :style="[props.inlineStyles]">
    <slot />
  </div>
</template>

<script setup>
import MobileDeviceDetect from "mobile-device-detect";

const componentName = "Layout";

// Props types: String, Number, Boolean, Array, Object, Function, Promise
const props = defineProps({
  className: {
    type: String,
  },
  inlineStyles: {
    type: Object,
    default: function () {
      return {
        // Style
      };
    },
  },
});

const isAndroid = ref(MobileDeviceDetect.isAndroid && "is-android");
const isIOS = ref(MobileDeviceDetect.isIOS && "is-ios");
const isChrome = ref(MobileDeviceDetect.isChrome && "is-chrome");
const isSafari = ref(MobileDeviceDetect.isSafari && "is-safari");
const isMobileSafari = ref(MobileDeviceDetect.isMobileSafari && "is-mobile-safari");
</script>

<style lang="scss">
::-webkit-scrollbar {
  width: none;
  /* width: 8px; */
  scrollbar-width: none;
  // specificscrollbarthumb-width
}

::-webkit-scrollbar-track {
  top: 178px;
  left: 2778px;
  padding: 2px 2px 2px 2px;
  // specificscrollbartrack-py specificscrollbartrack-px specificscrollbartrack-py specificscrollbartrack-px;
  gap: 0px;
   
  border-radius: $rounded-full;
  background: transparent;
}

::-webkit-scrollbar-thumb {
  width: none;
  scrollbar-width: none;
  /* width: 8px; */
  // specificscrollbarthumb-width
  gap: 0px;
   
  border: 1px solid white;
  border-radius: $rounded-full;
  background-color: #cbd5e1;
  // specific-scrollbar-thumb-background-color
}

.layout {
  overflow: overlay;
  /* Parent style   ------------------------------ */
  /* Children style ------------------------------ */
  /* Modifier style ------------------------------ */
}
</style>
